import {CommonModule} from '@angular/common';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {ConfigService} from '@shared-library';
import {
  FdkButtonComponent,
  FdkIllustrationComponent,
  FdkLinkComponent,
} from 'fasten-design-kit';

@Component({
  selector: 'app-splash',
  imports: [
    CommonModule,
    RouterModule,
    FdkButtonComponent,
    FdkIllustrationComponent,
    FdkLinkComponent,
  ],
  templateUrl: './splash.component.html',
  styleUrl: './splash.component.css',
  standalone: true,
})
export class SplashComponent {
  constructor(public configService: ConfigService) {}
}
